export const AD_LABEL_VIEW_MODE = {
    listView: 'listview',
    gridView: 'gridview',
  };
  
  export const AD_LABEL_TARGET = {
    listgrid: 'listgrid',
    adView: 'adview',
  };
  
  export const getImageLabelConfig = (ad, viewMode, target = AD_LABEL_TARGET.listgrid, isMobile) => {
    const adLabelConfig = ad?.ad_labels?.find((label) => label.label_type === 'top_left_image') || {};
    let image = '';
    if (isMobile) {
      if (target === AD_LABEL_TARGET.adView) {
        image = adLabelConfig.mobile_ad_view_image;
      } else {
        image = adLabelConfig.mobile_list_view_image;
      }
    } else {
      if (target === AD_LABEL_TARGET.adView) {
        image = adLabelConfig.web_ad_view_image;
      } else {
        image = adLabelConfig.web_list_view_image;
      }
    }
    return {
      image,
      viewMode,
      isMobile,
      target,
      redirectUrl: adLabelConfig.tooltip_redirect_url,
    };
  };
  
  export const getTextlabelConfig = (ad) => {
    const textLabelConfig =
      ad?.ad_labels
        ?.filter((label) => label.label_type === 'text')
        ?.map((config) => ({
          text: config.text,
          backgroundColor: config.background_color,
          color: config.text_color,
          tooltip: config.tooltip,
          redirectUrl: config.tooltip_redirect_url,
        })) || [];
    return textLabelConfig;
  };